import { FiltroAdminParametros, Parametro, SolicitudAdminParametro } from "../modelo/AdminParametro";

export const CONSULTAR_PARAMETROS = "CONSULTAR_PARAMETROS";
export const PARAMETROS_CONSULTADOS = "PARAMETROS_CONSULTADOS";
export const ERROR_CONSULTANDO_PARAMETROS = "ERROR_CONSULTANDO_PARAMETROS";

export const GESTIONAR_PARAMETRO = "GESTIONAR_PARAMETRO";
export const GESTION_EXITO = "GESTION_EXITO";
export const GESTION_ERROR = "GESTION_ERROR";
export const LIMPIAR_MENSAJES_PARAMETROS = "LIMPIAR_MENSAJES_PARAMETROS";

export const VENTANA_AYUDA_PARAMETRO = "VENTANA_AYUDA_PARAMETRO";

export const consultarParametros = (filtro: FiltroAdminParametros) => ({ type: CONSULTAR_PARAMETROS, filtro});
export const parametrosConsultados = (datosEntidad: Array<Parametro>, paginas: number, totalDatos: number) => ({ 
    type: PARAMETROS_CONSULTADOS, datosEntidad, paginas, totalDatos });
export const errorConsultandoParametros = () => ({ type: ERROR_CONSULTANDO_PARAMETROS });

export const gestionarParametro = (solicitud: SolicitudAdminParametro) => ({ type: GESTIONAR_PARAMETRO, solicitud});
export const gestionExito = () => ({ type: GESTION_EXITO});
export const gestionError = (mensaje: string) => ({ type: GESTION_ERROR, mensaje});
export const limpiarMensajesParametros = () => ({type: LIMPIAR_MENSAJES_PARAMETROS});

export const ventanaAyudaParametro = () => ({type: VENTANA_AYUDA_PARAMETRO});



// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_parametros/modulos/adminParametroActions.ts